<div *adaptLoading="!input"
     [ngClass]="{ 'competitor-analysis': isCompetitorAnalysis }">
    <adapt-collapsible-dashboard-element [name]="input!.name"
                                         [isCollapsible]="isCollapsible"
                                         [collapsed]="isCollapsible"
                                         [iconTooltip]="tooltip"
                                         [isExpandable]="!!input!.description"
                                         [overrideStyleClass]="overrideStyleClass"
                                         [iconClass]="iconClass ? iconClass + ' show-icon-on-print' : undefined"
                                         [handleId]="handleId">
        <div *adaptIfAuthorised="EditStrategicInputs"
             adapt-collapsible-header-action-right
             class="d-flex gap-1">
            @if (isEditing) {
                <button adaptButton="editBorderless"
                        adaptTooltip="Edit input"
                        tooltipPlacement="bottom"
                        [adaptBlockingClick]="editInput"
                        [stopPropagation]="true"></button>
            }
            @if (isDetachable) {
                <button class="text-black"
                        adaptButton="deleteBorderless"
                        (click)="onDeleted($event)"
                        adaptTooltip="Detach from strategic working board"
                        tooltipPlacement="bottom"></button>
            }
        </div>
        <div [froalaView]="input!.description"></div>
        @if (showCanvasNameInContent && input!.canvas) {
            <div class="d-flex flex-column">
                <span class="canvas-name mt-3">Canvas: {{ canvasName }}</span>
                @if (input?.inputGroup) {
                    <span class="canvas-name">{{ input!.inputGroup!.type }}: {{ input!.inputGroup!.name }}</span>
                }
            </div>
        }
    </adapt-collapsible-dashboard-element>
</div>
